import Alert from './Alert'
export default Alert
export type { IAlert } from './Alert.types'
